import React, { useState } from 'react';
import ecCouncilo from "../../assests/tech/ecCouncilo.webp";
const FixedImageWithToggleArrows = () => {
  // State to manage the visibility of the image and its button.
  const [isVisible, setIsVisible] = useState(true);

  // A single function to toggle the visibility state.
  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  return (
    <div>
      {/* Container for the image and the hide button. It only renders when the element is visible. */}
      {isVisible && (
        <div style={{
          position: 'fixed',
          bottom: '55px',
          right: '20px',
          zIndex: 99999, // Updated z-index
          display: 'flex',
          alignItems: 'center',
        }}>
          {/* The fixed image */}
          <img
            src={ecCouncilo}
            alt="Placeholder"
            style={{
              width: '200px',
              height: '156px',
            }}
          />

          {/* The arrow button to hide the image */}
          <button
            onClick={toggleVisibility}
            style={{
              marginLeft: '5px',
              fontSize: '24px',
              fontWeight: 'bold',
              border: 'none',
            //   background: 'trasparent',
              cursor: 'pointer',
              color: '#ff0000ff',
              padding: '0 5px',
              width: '40px',
            height: '40px',
            }}
          >
            &rarr;
          </button>
        </div>
      )}

      {/* This is the show button. It only renders when the element is NOT visible. */}
      {!isVisible && (
        <button
          onClick={toggleVisibility}
          style={{
            position: 'fixed',
            bottom: '69px',
            right: '20px',
            zIndex: 99999, // Updated z-index
            fontSize: '24px',
            fontWeight: 'bold',
            border: 'none',
            // background: '#ff0000ff',
            cursor: 'pointer',
            color: '#ff0000ff',
            // borderRadius: '50%',
            width: '40px',
            height: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            // boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
          }}
        >
          &larr;
        </button>
      )}

      {/* Dummy content */}
      {/* <div style={{ height: '2000px', padding: '20px' }}>
        <h2>Scroll down to see the element stay in place!</h2>
      </div> */}
    </div>
  );
};

export default FixedImageWithToggleArrows;